import { Component, OnInit, Input} from '@angular/core';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute} from '@angular/router';
import { Meta, Title } from "@angular/platform-browser";

import { ProfileService }       from '../_services/profile.service';
import { Globals }              from '../../Globals';

@Component({
  selector: 'mycourse',
  styleUrls: ['./mycourse.component.css'],
  templateUrl: './mycourse.component.html'
})

export class MycourseComponent implements OnInit{
  @Input() public loadData: boolean;
  posts;
  packages;
  reports;
  showModal=false;
  showModalReport=false;
  currentPackagesID;
  Math: any;
  body;
  mycourse;
  today;
  constructor(private globals: Globals, private profileService: ProfileService, private meta: Meta,private title: Title, private router: Router){
    this.Math = Math;
    this.body = document.getElementsByTagName('body')[0];
    this.today = new Date().getTime()
  }
  ngOnInit(){
    this.title.setTitle('My course');
    if(!this.mycourse)
    this.profileService.myCourse().subscribe(result => {
      this.mycourse = result.code === 200 ? result.data.items : [];
    });
  }
  trackByID(index, item){
    return item.id;
  }
  downloadReport(enroll_id){
    var form = document.createElement('FORM') as HTMLFormElement
    form.method = 'POST'
    form.action = this.globals.apiEndpoint + '/profile/course/report/download/' + enroll_id+'?token='+this.globals.token
    document.body.appendChild(form)
    form.submit()
  }
  downloadCertificate(enroll_id){
    var form = document.createElement('FORM') as HTMLFormElement
    form.method = 'POST'
    form.action = this.globals.apiEndpoint + '/profile/course/certificate/download/' + enroll_id+'?token='+this.globals.token
    document.body.appendChild(form)
    form.submit()
  }
}
